import { observer } from 'mobx-react';
import { Route, RouteProps, Redirect, useLocation } from 'react-router-dom';
import { useGlobalStore } from '../hooks/use_global_context';

interface RouterLocation {
    pathname: string;
    state: {
        [key: string]: any;
    };
}

export const AnonymousRoute: React.FC<React.PropsWithChildren<RouteProps>> = observer(props => {
    const { authStore } = useGlobalStore();
    const location = useLocation() as RouterLocation;
    const from = location.state?.from || { pathname: '/' };

    // Observing isUserSignedIn is what makes redirecting after login possible.
    // It also ensures logged in users can't access the anonymous page.
    if (authStore.isUserSignedIn) {
        return <Redirect to={from} />;
    }
    return <Route {...props}>{props.children}</Route>;
});
